var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 305,
    height: 305,
    viewBox: "0 0 305 305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.65,62.42c.08-2.85,.1-6.82-.3-11.55-.05-.56-.12-1.1-.22-1.64-.23-3.76-.5-6.38-.82-7.61-.85-3.23-3.81-6.69-29.4-10.5-9.63-1.43-21.5-2.75-34.69-3.86,1.07-4.14,2.48-12.88-2.6-18.68-4.04-4.61-10.86-5.93-20.28-3.94-1.88,.4-6.05,1.29-7.77,20.54-37.9-2-75.28-2.07-106.47-.33,1.21-3.68,2.02-8.92-.89-13.18-3.38-4.96-10.17-6.63-20.75-5.12-1.95,.28-6.34,.91-9.4,20.88-1.8,.21-3.57,.43-5.29,.65C24.64,33.01,6.63,41.68,6.71,54.62c.13,19.99-.48,47.1-1.12,75.79-.85,38.03-1.73,77.36-1.17,108.46,.92,51.4,5.51,56.76,10.54,58,10.79,2.65,81.04,4,141.74,4.12,3.3,0,6.57,0,9.81,0,20.93,0,40.66-.14,57.78-.42,3.41,.03,6.73,.07,9.91,.1,19.04,.18,34.08,.32,41.04,.61,.01,0,.03,0,.04,0,1.27,0,11.69-1.8,14.88-3.44,5.07-2.61,7.65-5.09,7.73-11.43l.67-55.18c.87-21.29,1.42-43.56,1.74-60.42,.78-40.01,.98-83.25,.33-108.41ZM13.47,130.58c.64-28.75,1.25-55.91,1.12-76.01-.03-4.2,5.52-7.57,10.17-9.65,8.92-4,23.21-7.18,41.7-9.44l.06,35.96c0,1.05,.42,2.06,1.17,2.8,.74,.74,1.74,1.15,2.79,1.15h.02l20.29-.08c2.11,0,3.84-1.67,3.94-3.78l1.72-38.68c22.46-1.34,48.6-1.7,77.24-.97,10.71,.27,20.84,.67,30.32,1.16l-2.68,33.74c-.17,2.14,1.4,4.03,3.54,4.25l22.62,2.3c.13,.01,.27,.02,.4,.02,.93,0,1.83-.33,2.55-.93,.82-.69,1.32-1.68,1.4-2.75l2.47-34.61c22.97,1.93,39.92,4.35,49.44,6.56l-5.58,225.31c.02,5.08-.77,17.08-8.64,18.71-2.22,.46-15.31,.07-16.82,0l-237.76-6.63c-.08,0-.15,0-.23,0-1.1-7.77-2.15-21.15-2.46-44.2-.42-30.35,.42-67.89,1.23-104.2Z",
    fill: "#0C62FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.24,262.62l183.79,.39h0c11.34,0,18.66-5.55,18.66-14.08l2.26-140.07c0-9-7.21-15.28-17.63-15.28h0l-184.63,4.52c-9.54,0-15.25,5.68-15.28,15.21l-4.51,132.04s0,.09,0,.14c0,9.46,7.78,17.15,17.33,17.15Zm-4.84-149.11s0-.09,0-.14c0-5.12,2.18-7.3,7.4-7.31l184.63-4.52c4.41,0,9.56,1.91,9.56,7.24l-2.26,140.07c0,5.87-8.88,6.17-10.68,6.17l-183.8-.39c-5.14,0-9.33-4.08-9.37-9.11l4.51-132.03Z",
    fill: "#0C62FB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.63,
    y: 121.78,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98.96,
    y: 121.78,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 136.28,
    y: 121.78,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 173.61,
    y: 121.78,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 210.94,
    y: 121.78,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 61.63,
    y: 166.57,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 98.96,
    y: 166.57,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 136.28,
    y: 166.57,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 173.61,
    y: 166.57,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 210.94,
    y: 166.57,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 61.63,
    y: 211.35,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 98.96,
    y: 211.35,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 136.28,
    y: 211.35,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 173.61,
    y: 211.35,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 210.94,
    y: 211.35,
    width: 19.55,
    height: 19.55,
    rx: 3.73,
    ry: 3.73,
    fill: "#0C62FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3c7805f435eebcf08a352582d4535076.svg";
export { ForwardRef as ReactComponent };